import { GetCallMetadataIO } from '../types';
import { UseCallIntelV2QueryEndpointArgs, useCallIntelV2Query } from './use-call-intel-v2-query';

/**
 * A hook that returns a query for the `GetCallMetadata` endpoint.
 * @param request The request object to pass to the query.
 * @param options (optional) The options to pass to `useQuery`.
 * @param httpOptions (optional) The http options to pass to the schema function.
 * @param fallbackDataOnError (optional) The fallback data to use when an error occurs. This will not be persisted to the cache.
 * @param requestKeysToOmitFromQueryKey (optional) - An array of keys to omit from the query key. This is useful for cases where the request object contains keys that cause issues
 * when included in the query key, such as the current timestamp.
 */
export const useGetCallMetadataQuery = <E = unknown, D = GetCallMetadataIO['output']>(
  args: UseCallIntelV2QueryEndpointArgs<'GetCallMetadataNew', E, D>
) =>
  useCallIntelV2Query({
    endpointName: 'GetCallMetadataNew',
    ...args,
  });
